/**
 * Clamps a `?page=` query param to a 1-based page number. Non-numeric values,
 * values below 1, and repeated params (which Next.js hands over as `string[]`)
 * all collapse to page 1.
 */
export const resolvePageParam = (
	value: string | string[] | null | undefined,
): number => {
	const parsed = Number.parseInt(typeof value === "string" ? value : "", 10);
	return Number.isFinite(parsed) && parsed >= 1 ? parsed : 1;
};
